module.exports = __webpack_public_path__ + "static/media/order_empty.a436e4dc.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/order_empty.png
// module id = 108
// module chunks = 38